// extracted by mini-css-extract-plugin
module.exports = {"container":"purchasePoints_container__udZ2r","buttons":"purchasePoints_buttons__3Ezkd"};